<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'

import ProjectIndexCard from '@/components/project/ProjectIndexCard.vue'

const store = useStore()

const items = computed(() => store.state.project.projects)
const loading = computed(() => store.state.project.loading)

const showAlert = computed(() => items.value?.length === 0)
</script>
<template>
  <div ref="input" v-if="!loading">
    <v-card-subtitle v-if="!items?.length"> There are no projects available.</v-card-subtitle>
    <v-row no-gutters v-else-if="items.length">
      <v-col v-for="item in items" :key="item.id" class="pa-3" cols="12" md="3" sm="6" xs="12">
        <ProjectIndexCard :item="item"></ProjectIndexCard>
      </v-col>
    </v-row>
    <v-alert v-if="showAlert" type="warning" density="compact" class="mt-4" variant="tonal">
      There are no projects available. Please create a project to proceed.
    </v-alert>
  </div>
</template>
